<div class="app">
  <a [href]="appStoreLink" target="_blank">
    <img src="assets/images/appStore.svg" alt="App Store">
  </a>

  <a [href]="googlePlayLink" target="_blank" class="mr-15">
    <img src="assets/images/googlePlay.svg" alt="Google Play">
  </a>
</div>
